import { RootState } from "./store";
import { UserRole } from "./userSlice";

const rolePriority: UserRole[] = ["isOwner", "isAdmin", "isManager", "isStaff"];

export const selectAuthUser = (state: RootState) => state.auth;
export const selectGoldRate = (state: RootState) => state.goldRate;
export const selectDiamondRates = (state: RootState) => state.diamondRates;
export const selectUserDetails = (state: RootState) => state.user;
export const selectProducts = (state: RootState) => state.products;
export const selectCustomers = (state: RootState) => state.customers;
export const selectBills = (state: RootState) => state.bills;
export const selectShoppingBucketItems = (state: RootState) => state.shoppingBucket;
export const selectTotalProductsCount = (state: RootState) => state.totalProductsCount;
export const selectIsAuthenticated = (state: RootState) => Boolean(state.auth.uid);
export const selectHasUserRole = (state: RootState, roles: UserRole[]) =>
    roles.some((role) => state.user[role]);
export const selectHighestUserRole = (state: RootState) =>
    rolePriority.find((role) => state.user[role]) ?? null;
export const selectHasAdminAccess = (state: RootState) =>
    selectHasUserRole(state, ["isAdmin", "isManager", "isStaff", "isOwner"]);
